import React, { useEffect, useState } from 'react'
import './Payment.css'
import { useStateValue } from './StateProvider'
import CheckoutProduct from './CheckoutProduct';
import { Link, useNavigate } from 'react-router-dom';
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js"
import { NumericFormat } from 'react-number-format';
import { getBasketTotal } from './reducer';
import axios from './axios';
import { db } from './firebase';
import { doc, setDoc, collection } from "firebase/firestore";


const Payment = () => {
    const [{ basket, user }, dispatch] = useStateValue();
    const navigate = useNavigate();
    const stripe = useStripe();
    const elements = useElements();

    const [succeeded, setSucceeded] = useState(false);
    const [processing, setProcessing] = useState("");
    const [error, setError] = useState(null);
    const [disable, setDisable] = useState(true);
    const [clientSecret, setClientSecret] = useState("");

    useEffect(() => {
    const getClientSecret = async () => {
        // Multiply by 100 and round to integer
        const total = Math.round(getBasketTotal(basket) * 100);

        try {
            const response = await axios.post(`/payments/create?total=${total}`);

            setClientSecret(response.data.clientSecret);
        } catch (err) {
            console.error("Failed to get client secret:", err);
            setError("Payment initialization failed. Please try again.");
        }
    };

    if (basket.length > 0) {
        getClientSecret();
    }
}, [basket]);

    console.log('THE SECRET IS >>>', clientSecret)

    const handleSubmit = async (event) => {
        // do all the fancy stripe stuff...
    event.preventDefault();
    setProcessing(true);

    if (!stripe || !elements) return;

    try {
        const payload = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardElement)
            }
        });

        if (payload.error) {
            setError(`Payment failed: ${payload.error.message}`);
            setProcessing(false);
        } else {
            // paymentIntent = payment confirmation
            
            const paymentIntent = payload.paymentIntent;  // <-- add this line

            await setDoc(
                doc(collection(doc(collection(db, "users"), user?.uid), "orders"), paymentIntent.id),
                {
                    basket: basket,
                    amount: paymentIntent.amount,
                    created: paymentIntent.created,
                }
                );

            setSucceeded(true);
            setError(null);
            setProcessing(false);

            dispatch({
                type: 'EMPTY_BASKET'
            })
            navigate('/orders', { replace: true });
        }
    } catch (err) {
        console.error(err);
        setError("Payment failed. Please try again.");
        setProcessing(false);
    }
};

    const handleChange = event => {
        // Listen for changes in the CardElement
        // and display and errors as the customer types their card details
        setDisable(event.empty);
        setError(event.error ? event.error.message : "");
    }
  return (
    <div className='payment'>
        <div className='payment__container'>
            {/* container h1 a denote to it */}
        <h1>
        Checkout (
            <Link to="/checkout">{basket?.length} item</Link>
            )
        </h1>
            {/* payment section - delivery address */}
            <div className='payment__section'>
                <div className='payment__title'>
                    <h3>Delivery Address</h3>
                </div>
                <div className='payment__address'>
                    <p>{user?.email}</p>
                    <p>123 React Lane</p>
                    <p>Los Orissa</p>
                </div>

            </div>

            {/* payment section - review Items */}
            <div className='payment__section'>
                <div className='payment__title'>
                    <h3>Review item and delivery</h3>
                </div>
                <div className='payment__item'>
                    {basket.map(item => (
                        <CheckoutProduct
                            id={item.id}
                            title={item.title}
                            image={item.image}
                            price={item.price}
                            rating={item.rating}
                        />
                    ))}
                </div>


            </div>

            {/* payment section - payment method */}
            <div className='payment__section'>
                <div className='payment__title'>
                    <h3>Payment Method</h3>
                </div>
                <div className='payment__details'>
                    {/* strip magic will go */}

                    <form onSubmit={handleSubmit}>
                        <CardElement onChange={handleChange}/>

                        <div className='payment__priceCountainer'>
                            <NumericFormat
                                renderText={(value) => (
                                    <>
                                    <h3>Order Total: {value}</h3>
                                    </>
                                )}
                                decimalScale={2}
                                value={getBasketTotal(basket)}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"$"}
                            />
                            <button disabled={processing || disable ||
                            succeeded}>
                                <span>{processing ? <p>Processing</p> :
                                "Buy Now"}</span>
                            </button>
                        </div>

                        {/* ERROR */}
                        {error && <div>{error}</div>}
                    </form>
                </div>


            </div>
        </div>      
    </div>
  )
}

export default Payment
